import type { TemplateData } from '@plone-collective/volto-editortemplates/types';

export const GET_BLOCK_TEMPLATES = 'GET_BLOCK_TEMPLATES';
export const GET_BLOCK_TEMPLATES_PENDING = 'GET_BLOCK_TEMPLATES_PENDING';
export const GET_BLOCK_TEMPLATES_SUCCESS = 'GET_BLOCK_TEMPLATES_SUCCESS';
export const GET_BLOCK_TEMPLATES_FAIL = 'GET_BLOCK_TEMPLATES_FAIL';
export const GET_BLOCK_TEMPLATE = 'GET_BLOCK_TEMPLATE';
export const GET_BLOCK_TEMPLATE_PENDING = 'GET_BLOCK_TEMPLATE_PENDING';
export const GET_BLOCK_TEMPLATE_SUCCESS = 'GET_BLOCK_TEMPLATE_SUCCESS';
export const GET_BLOCK_TEMPLATE_FAIL = 'GET_BLOCK_TEMPLATE_FAIL';

export const ADD_BLOCK_TEMPLATE = 'ADD_BLOCK_TEMPLATE';
export const ADD_BLOCK_TEMPLATE_PENDING = 'ADD_BLOCK_TEMPLATE_PENDING';
export const ADD_BLOCK_TEMPLATE_SUCCESS = 'ADD_BLOCK_TEMPLATE_SUCCESS';
export const ADD_BLOCK_TEMPLATE_FAIL = 'ADD_BLOCK_TEMPLATE_FAIL';

export const UPDATE_BLOCK_TEMPLATE = 'UPDATE_BLOCK_TEMPLATE';
export const UPDATE_BLOCK_TEMPLATE_PENDING = 'UPDATE_BLOCK_TEMPLATE_PENDING';
export const UPDATE_BLOCK_TEMPLATE_SUCCESS = 'UPDATE_BLOCK_TEMPLATE_SUCCESS';
export const UPDATE_BLOCK_TEMPLATE_FAIL = 'UPDATE_BLOCK_TEMPLATE_FAIL';

export const DELETE_BLOCK_TEMPLATE = 'DELETE_BLOCK_TEMPLATE';
export const DELETE_BLOCK_TEMPLATE_PENDING = 'DELETE_BLOCK_TEMPLATE_PENDING';
export const DELETE_BLOCK_TEMPLATE_SUCCESS = 'DELETE_BLOCK_TEMPLATE_SUCCESS';
export const DELETE_BLOCK_TEMPLATE_FAIL = 'DELETE_BLOCK_TEMPLATE_FAIL';

export const RESET_BLOCK_TEMPLATE_RESULTS = 'RESET_BLOCK_TEMPLATE_RESULTS';

const crudActions = [
  GET_BLOCK_TEMPLATE,
  GET_BLOCK_TEMPLATES,
  ADD_BLOCK_TEMPLATE,
  UPDATE_BLOCK_TEMPLATE,
  DELETE_BLOCK_TEMPLATE,
] as const;
const availableActions = [
  GET_BLOCK_TEMPLATES_SUCCESS,
  GET_BLOCK_TEMPLATES_PENDING,
  GET_BLOCK_TEMPLATES_FAIL,
  GET_BLOCK_TEMPLATE_SUCCESS,
  GET_BLOCK_TEMPLATE_PENDING,
  GET_BLOCK_TEMPLATE_FAIL,
  ADD_BLOCK_TEMPLATE_PENDING,
  ADD_BLOCK_TEMPLATE_FAIL,
  ADD_BLOCK_TEMPLATE_SUCCESS,
  UPDATE_BLOCK_TEMPLATE_PENDING,
  UPDATE_BLOCK_TEMPLATE_FAIL,
  UPDATE_BLOCK_TEMPLATE_SUCCESS,
  DELETE_BLOCK_TEMPLATE_PENDING,
  DELETE_BLOCK_TEMPLATE_FAIL,
  DELETE_BLOCK_TEMPLATE_SUCCESS,
  RESET_BLOCK_TEMPLATE_RESULTS,
] as const;
type CrudActions = (typeof crudActions)[number];
type AvailableActions = (typeof availableActions)[number];

interface CrudAction<T = CrudActions> {
  type: T;
  request: {
    op: string;
    path: string;
    data?: TemplateData;
  };
  subrequest?: string;
}

function getBlockTemplates(searchQuery: string = ''): CrudAction {
  return {
    type: GET_BLOCK_TEMPLATES,
    request: {
      op: 'get',
      path: `/@block-template${searchQuery ? `?name=${searchQuery}` : ''}`,
    },
  };
}
function getBlockTemplate(uid: string = '', subrequest: string): CrudAction {
  return {
    type: GET_BLOCK_TEMPLATE,
    subrequest,
    request: {
      op: 'get',
      path: `/@block-template/${uid}`,
    },
  };
}

function addBlockTemplate(templateData: TemplateData): CrudAction {
  return {
    type: ADD_BLOCK_TEMPLATE,
    request: {
      op: 'post',
      path: '/@block-template',
      data: templateData,
    },
  };
}

function updateBlockTemplate(templateData: TemplateData): CrudAction {
  return {
    type: UPDATE_BLOCK_TEMPLATE,
    request: {
      op: 'patch',
      path: `/@block-template`,
      data: templateData,
    },
  };
}
function deleteBlockTemplate(templateData: TemplateData): CrudAction {
  return {
    type: DELETE_BLOCK_TEMPLATE,
    request: {
      op: 'del',
      path: `/@block-template`,
      data: templateData,
    },
  };
}
function resetBlockTemplatesResults() {
  return {
    type: RESET_BLOCK_TEMPLATE_RESULTS,
  };
}
export {
  addBlockTemplate,
  getBlockTemplates,
  getBlockTemplate,
  updateBlockTemplate,
  deleteBlockTemplate,
  resetBlockTemplatesResults,
};
export type { AvailableActions, CrudAction, CrudActions };
